export default __webpack_public_path__ + "media/images/images/logo/logo-dark-lg-956fc0f4d20533bc8b127b1cbc99af9e.png";